import React, { FC } from "react";

type SearchDesktopPropTypes = {
  children: React.ReactNode;
};

/**
 * Desktop search: renders search content inline with no overlay or toggle.
 * Shown when parent uses viewport width >= 992px (`useNonDesktopViewport` false).
 */
const SearchDesktop: FC<SearchDesktopPropTypes> = ({ children }) => {
  return <>{children}</>;
};

export default SearchDesktop;
